import { useState, useEffect } from "react";

const SOPHIA_IMAGE = "https://customer-assets.emergentagent.com/job_20bc98a4-4331-40ab-b07e-fb5b25585751/artifacts/8tur9abd_9AE940BD-27AA-4FC0-9402-213532B07955.png";

const SplashScreen = ({ onComplete }) => {
  const [phase, setPhase] = useState(0); // 0: initial, 1: image, 2: title, 3: tagline, 4: fade out

  useEffect(() => {
    const timers = [
      setTimeout(() => setPhase(1), 500),    // Show image
      setTimeout(() => setPhase(2), 2000),   // Show title
      setTimeout(() => setPhase(3), 3500),   // Show tagline
      setTimeout(() => setPhase(4), 5500),   // Start fade out
      setTimeout(() => onComplete(), 6500),  // Complete
    ];

    return () => timers.forEach(t => clearTimeout(t));
  }, [onComplete]);

  return (
    <div 
      className={`splash-screen ${phase >= 4 ? 'fade-out' : ''}`}
      data-testid="splash-screen"
    >
      {/* Animated background particles */}
      <div className="splash-particles">
        {[...Array(20)].map((_, i) => (
          <div 
            key={i} 
            className="particle"
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${3 + Math.random() * 4}s`
            }}
          />
        ))}
      </div>

      {/* Glow rings */}
      <div className={`glow-ring ring-1 ${phase >= 1 ? 'active' : ''}`} />
      <div className={`glow-ring ring-2 ${phase >= 1 ? 'active' : ''}`} />
      <div className={`glow-ring ring-3 ${phase >= 2 ? 'active' : ''}`} />

      {/* SophIA Image */}
      <div className={`splash-image-container ${phase >= 1 ? 'visible' : ''}`}>
        <img 
          src={SOPHIA_IMAGE} 
          alt="SophIA" 
          className="splash-image"
        />
        <div className="image-glow" />
      </div>

      {/* Title */}
      <div className={`splash-title ${phase >= 2 ? 'visible' : ''}`}>
        <span className="title-soph">Soph</span>
        <span className="title-ia">IA</span>
      </div>

      {/* Tagline */}
      <div className={`splash-tagline ${phase >= 3 ? 'visible' : ''}`}>
        Intelligence Artificielle de la Sagesse
      </div>

      {/* Loading indicator */}
      <div className={`splash-loader ${phase >= 3 ? 'visible' : ''}`}>
        <div className="loader-bar" />
      </div>
    </div>
  );
};

export default SplashScreen;
